import ResultsMap from '../../../shared/complexTools/ResultsMap';

export default ResultsMap;
